// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "../../material-icons.css"; */


.admin {
  flex-grow: 1;
  padding: 0 10px 10px;
}

.admin .content__header .options .button:not(.icon) {
  background-color: var(--button-bg-darker);
}

.admin .prompt__container .sidebar__select {
  padding: 0;
}

.admin.group .prompt__backdrop {
  z-index: 0;
  height: 100%;
  position: unset;
  background: white;
}
.admin.group .prompt__backdrop > .prompt__container {
  box-shadow: 0 0 15px 5px var(--button-bg-darker);
}


/* IP Address + Port Number text input */

.admin .prompt__container .loc__port input[type="numeric"],
.admin .prompt__container .loc__port input[type="numeric"] {
  outline: 0;
  border: none;
  max-width: 40px;
  margin-right: 2px;
  text-align: center;
}


/* Print Report --- smaller for accounts and locations */

.admin:not(.groups) #print th, .admin:not(.groups) #print td {
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Admin/Admin.css"],"names":[],"mappings":"AAAA,wCAAwC;;;AAGxC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gDAAgD;AAClD;;;AAGA,wCAAwC;;AAExC;;EAEE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,wDAAwD;;AAExD;EACE,eAAe;AACjB","sourcesContent":["/* @import \"../../material-icons.css\"; */\r\n\r\n\r\n.admin {\r\n  flex-grow: 1;\r\n  padding: 0 10px 10px;\r\n}\r\n\r\n.admin .content__header .options .button:not(.icon) {\r\n  background-color: var(--button-bg-darker);\r\n}\r\n\r\n.admin .prompt__container .sidebar__select {\r\n  padding: 0;\r\n}\r\n\r\n.admin.group .prompt__backdrop {\r\n  z-index: 0;\r\n  height: 100%;\r\n  position: unset;\r\n  background: white;\r\n}\r\n.admin.group .prompt__backdrop > .prompt__container {\r\n  box-shadow: 0 0 15px 5px var(--button-bg-darker);\r\n}\r\n\r\n\r\n/* IP Address + Port Number text input */\r\n\r\n.admin .prompt__container .loc__port input[type=\"numeric\"],\r\n.admin .prompt__container .loc__port input[type=\"numeric\"] {\r\n  outline: 0;\r\n  border: none;\r\n  max-width: 40px;\r\n  margin-right: 2px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n/* Print Report --- smaller for accounts and locations */\r\n\r\n.admin:not(.groups) #print th, .admin:not(.groups) #print td {\r\n  font-size: 11px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
